import { useHistory } from 'react-router-dom';
import StyledButton from '../../components/StyledButton';
import PageNotFound from './PageNotFound';

import './NotFound404.scss';
import { AdminRouteName } from '../CONSTANTS';

const NotFound404 = () => {
  const { push } = useHistory();
  return (
    <div className="not-found">
      <div className="info">
        <h3>Page Not Found</h3>
        <p>Sorry, the requested page could not be found.</p>
        <StyledButton
          name="Explore Customers"
          onClick={() => {
            push(AdminRouteName.customersRoute);
          }}
          padding="10px"
          backgroundColor="black"
          color="#fff"
          fontSize="13px"
          borderRadius="4px"
          border="1px solid #dcd8ec"
          marginLeft="16px"
        />
      </div>
      <div className="illustration">
        <PageNotFound />
      </div>
    </div>

  );
};

export default NotFound404;
